import { DriverForm } from 'src/scenes/Driver/components/DriverForm';
import { DriverFormValues } from 'src/scenes/Driver/components/DriverForm/driverSchema';
import { ErrorAlert, LoadingIndicator } from '@sgi/gravity';
import { useSearchDriverByCustomerNumber } from 'src/scenes/Driver/DriverDetailView/state/useSearchDriverByCustomerNumber';
import { SearchDriverByCustomerNumberDetailDto } from 'src/types/DriverHubBFFOpenAPI';
import { coerceDate } from 'src/utils/dateUtils';

interface DriverDetailViewProps {
  customerNumber: string;
  onCancel?: () => void;
}

function createInitialValues(dto: SearchDriverByCustomerNumberDetailDto): DriverFormValues {
  return {
    customerNumber: dto.customerNumber.toString(),
    driversLicenceNumber: dto.customerNumber.toString(),
    dateOfBirth: coerceDate(dto.dateOfBirth),
    licenceExpiryDate: undefined,
    driversLicenceClass: '',
    driversLicenceJurisdiction: '',
    endorsementsRestrictions: [],
    firstName: dto.firstName ?? '',
    middleName: dto.middleName ?? '',
    lastName: dto.lastName ?? '',
    addressLine1: dto.mailingAddress?.addressLine1 ?? '',
    addressLine2: dto.mailingAddress?.addressLine2 ?? '',
    city: dto.mailingAddress?.city ?? '',
    jurisdiction: dto.mailingAddress?.jurisdiction?.longDescription ?? '',
    country: dto.mailingAddress?.country?.longDescription ?? '',
    postalCode: dto.mailingAddress?.postalCode ?? '',
  };
}

export const DriverDetailView = ({ customerNumber, onCancel }: DriverDetailViewProps) => {
  const { data: driverInfo, isLoading, error } = useSearchDriverByCustomerNumber(customerNumber);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (error || !driverInfo) {
    return <ErrorAlert>Unable to find customer</ErrorAlert>;
  }

  return <DriverForm initialValues={createInitialValues(driverInfo)} isSubmitting={false} onCancel={onCancel} isEdit={false} />;
};
